// extracted by mini-css-extract-plugin
export default {"container":"Xk-z","disabled":"Yk-z","subtotal":"Zk-z","legal":"_k-z"};